module.exports = __webpack_public_path__ + "static/media/azure_logo.876b8c3f.svg";